import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const GamstopPreviouslyPositiveCustomLimitConfigurationWrapper = styled('div', { label: 'GamstopPreviouslyPositiveCustomLimitConfigurationWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: -4px 0 0 28px;
`;

export const GamstopPreviouslyPositiveCustomLimitConfigurationPanels = styled('div', { label: 'GamstopPreviouslyPositiveCustomLimitConfigurationPanels' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const GamstopPreviouslyPositiveCustomLimitConfigurationActions = styled('div', { label: 'GamstopPreviouslyPositiveCustomLimitConfigurationActions' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const GamstopPreviouslyPositiveAgeRestrictionButton = styled('button', { label: 'GamstopPreviouslyPositiveAgeRestrictionButton' })`
    align-self: flex-start;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    font-family: var(--font-family-primary);
    font-size: 13px;
    line-height: 1.38;
    font-weight: 500;
    color: ${mainColors.main.secondary};
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
